import Aside from '@src/components/Organism/Aside/Index';
import { devices } from '@src/styles/theme';
import React from 'react';
import styled from 'styled-components';

type Props = {
  children: React.ReactNode;
  padding?: string;
  paddingBottom?: string;
};

const AuthContainer = ({ children, padding, paddingBottom }: Props) => {
  return (
    <Container>
      <AuthWrap padding={padding} paddingBottom={paddingBottom}>
        {children}
        <RegistSideWrap>
          <Aside isListPage={true} disabledTop={true} />
        </RegistSideWrap>
      </AuthWrap>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RegistSideWrap = styled.div`
  position: absolute;
  bottom: 0px;
  right: -90%;
  @media ${devices.tablet} {
    display: none;
  }
`;

const AuthWrap = styled.div<Props>`
  position: relative;
  background-color: #fff;
  width: 500px;
  margin: 0 auto;
  padding: ${(props) => props.padding};
  padding-bottom: ${(props) => props.paddingBottom};
  border-radius: 10px;
  height: 100%;
  @media ${devices.tablet} {
    height: 100%;
    padding: 0px;
    width: 100%;
  }
`;

export default AuthContainer;
